import React from 'react';
import classes from './SocialLinks.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faGithub,
  faHackerrank,
  faLinkedin,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';

const socials = [
  { name: 'Github', icon: faGithub, src: 'https://github.com/AzherUddin617', color: '#FFFFFF', bg: '#393E41' },
  { name: 'HackerRank', icon: faHackerrank, src: 'https://www.hackerrank.com/azheruddin617mr1', color: '#2EBD5E', bg: '#F7F7F7' },
  { name: 'LinkedIn', icon: faLinkedin, src: 'https://www.linkedin.com/in/azher-uddin-660b791b2/', color: '#0A66C2', bg: '#FFFFFF' },
  { name: 'Instagram', icon: faInstagram, src: 'https://www.instagram.com/azh3r_i/', color: '#FBFBFB', bg: ['#FFE082', '#F51D61', '#4841EA'] },
  { name: 'Facebook', icon: faFacebook, src: 'https://www.facebook.com/azher.uddin.617', color: '#3A589E', bg: '#FFFFFF' },
];

const SocialLinks = ({ className, style }) => {
  const rootClass = [classes.SocialLinks];
  if (className) rootClass.push(className);

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>
      {socials.map((social, i)=> {

        return (
          <a href={social.src} className={classes.SocialLink} title={social.name} key={i}>
            <span className={classes.Bg} style={{
              background: Array.isArray(social.bg)
                ? `linear-gradient(to top right, ${social.bg[0]}, ${social.bg[1]}, ${social.bg[2]})`
                : social.bg
            }}></span>
            <FontAwesomeIcon icon={social.icon} color={social.color} fontSize="inherit" />
          </a>
        );
      })}
    </div>
  );
}

export default SocialLinks;